<div #user_list class="at-who">
  <mat-action-list appScrollable id="at_who_user_list" tabindex="1">
    <button (click)="addWho(user)" (mouseover)="updateCurrent(user)" *ngFor="let user of filtered_users"
            [ngClass]="{'current': user===filtered_users[list_index]}"
            mat-list-item> {{user.attributes.name }} </button>
  </mat-action-list>
</div>
